export default __webpack_public_path__ + "static/media/button.07edccdd.svg";